// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesMatchesEntityStream } from '../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { basketStatuses } from '../constants';

const getBasketStatus = (state) => state.immersive.status;

const getShouldShowBasket = createSelector([getBasketStatus], (basketStatus) => basketStatus !== basketStatuses.EMPTY);

export const immersiveSelector = createSelector(
  [getShouldShowBasket, selectEntitiesMatchesEntityStream, getBasketStatus],
  (shouldShowBasket, streamData, basketStatus) => ({
    shouldShowBasket,
    streamData,
    basketStatus,
  }),
);
